import config from '../config/config';
import { client as batchClient } from '../services/batchChainClient';
import TowerService from '../services/towerService';
import {
  OfferMessage,
} from '@atomicfinance/bitcoin-dlc-provider';

export default class DlcDetectionService {
  private tower: TowerService;

  constructor(tower: TowerService) {
    this.tower = tower;
  }

  async getDlcFundingStages(): Promise<any> {
    const rawContracts = await this.tower?.getContracts()

    const offererPubkeys = rawContracts.map(contract => contract.offererPubkey).filter((x, i, a) => a.indexOf(x) === i)

    const offers: OfferMessage[] = []
    const contracts = {}

    await Promise.all(
      offererPubkeys.map(async (pubkey, index) => {
        const offersResponse = await this.tower?.getOffers(pubkey)

        if (offersResponse) {
          const { data: _offers } = offersResponse;

          for (let i = 0; i < _offers.length; i++) {
            const offer = OfferMessage.fromJSON(JSON.parse(_offers[i].offerData));
            offers.push(offer)

            const { localPartyInputs: { utxos } } = offer

            const outspend = await (
              await fetch(`${config.bitcoin.api}/tx/${utxos[0].txid}/outspend/${utxos[0].vout}`)
            ).json();

            const { spent } = outspend
            if (spent) {
              const { txid } = outspend

              const tx = await batchClient.client.getMethod('getTransaction')(txid)
              const { _raw: { vin, vout } } = tx

              if (vin.length === 2 && vout.length >= 1 && vout.length <= 3) {
                contracts[offer.contractId] = { stage: 'ACTIVE', txid }
              } else {
                contracts[offer.contractId] = { stage: 'CANCELLED', txid }
              }
            } else {
              contracts[offer.contractId] = { stage: rawContracts.find(contract => contract.UUID === offer.contractId).contractStage }
            }
          }
        }
      })
    )

    return contracts
  }
}
